import React, { useRef, useState, useEffect } from 'react';
import DataTable from "react-data-table-component";
import {useForm} from 'react-hook-form';
import moment from 'moment-timezone';

import {
    Alert,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardHeader,
    Container,
    CardText,
    Button,
    Row,
    Col,
    Badge,
    Input,
    Image,
    Form,
    FormGroup,
    Label,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Table,
    TabContent, TabPane, Nav, NavItem, NavLink, 
} from "reactstrap";

import Header from 'components/Headers/Header';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2'
import { getUserData } from 'redux/UserAuthentication/LoginActions';
import { app, db } from "../../firebase";
import { getDocs, getDoc, setDoc, addDoc, collection, query, where, onSnapshot, doc, orderBy, limit } from "firebase/firestore";
import { deleteCommunityPost } from 'redux/Community/CommunityAction';
import Post from 'components/Community/Post';

const ManagePosts = (props) => {
    const dispatch = useDispatch();
    const [data, setData]= useState([]);
    const [search, setSearch]= useState('');
    const [filter, setFilter] = useState([]);
    const [postId, setPostId] = useState('');
    const [postItem, setPostITem] = useState([]);

    //Modal Behaviour 
    const [modal, setModal] = useState(false);
    const modalToggle = () => setModal(!modal);
    const [backdrop, setBackdrop] = useState(true);


    //Show posts in realtime
    useEffect(() => {
        const unsub = onSnapshot(query(collection(db, "communityPosts"), orderBy("updatedAt", "desc")), (snapshot) => {
            setData(
                snapshot.docs.map(
                    (doc) => (
                        { ...doc.data(), postid: doc.id }
                    )
                )
            )
            setFilter(
                snapshot.docs.map(
                    (doc) => (
                        { ...doc.data(), postid: doc.id }
                    )
                )
            )
        },(error) => {
            
        }
        );
        return unsub
    }, []);

    const truncate = (str,n) => {
        return (str.length > n) ? str.slice(0, n-1) + ' ...' : str;
    }

    const columns= [
        {
            name:"#",
            selector: (row) => row.postid,
            wrap: true,
        },
        {
            name:"Content",
            selector: (row) => truncate(row.textContent,40),
            wrap: true,
        },
        {
            name:"Files",
            selector: (row) => (
                row.fileContent.length ? 
                     row.fileContent.map((f, i) => {
                         return (
                             f.file.mimeType == "video/mp4"
                            ?
                                <video controls width="50" height="50" style={{ backgroundColor: '#000' }} >
                                    <source
                                        type={f.file.mimeType}
                                        src={'https://storage.googleapis.com/pre-dental-tracker.appspot.com/community-upload/' + f.name}
                                    />
                                </video>
                            :
                            <img width="50" height="50" src={'https://storage.googleapis.com/pre-dental-tracker.appspot.com/community-upload/' + f.name} /> 
                        )
                    })
                : 'No Files... '
               
            ),
            wrap: true,
        },
        {
            name:"Date",
            selector: (row) => moment(row.updatedAt).format("MMM Do YY"),
           
        },
        {
            name:"Action",
            cell: (row) => (
                <>
                    <a className="btn btn-sm btn-primary" onClick={e => onClickViewPost(e, row.postid, row)} ><i className="fas fa-eye"></i> View</a> 
                    {
                        props.userDetails.admin === true || props.userDetails.admin == 'true'
                            ? 
                            <a className="btn btn-sm btn-warning" onClick={()=>handleDelete(row.postid)}><i className="fas fa-trash"></i> Delete</a>
                        : ''     
                    }
                    
                </>
               
            ),
            width: '20rem',
            center: true
        }

    ];

    useEffect(()=>{
        const result = data.filter((item) => {
            return item.textContent.toLowerCase().match(search.toLocaleLowerCase());
        });
        setFilter(result);
    }, [search]);
    
      //On Click Edit Post
    const onClickViewPost = async (e, postid, item) => {
        const docRef = doc(db, "communityPosts", postid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let postitem = docSnap.data();
            postitem['postid'] = postid
            // setItem(postitem)
        } else {
        // docSnap.data() will be undefined in this case
            console.log("No such document!");
        }
        e.preventDefault();
        setPostId(postid)
        setPostITem(item)
        setBackdrop(true);
        setModal(true)
        
    
    }

    const handleDelete = (val) => {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#3085d6',
            confirmButtonColor: '#d33'
        }).then((result) => {
           
            if (result.isConfirmed) {
                dispatch(deleteCommunityPost({ postid: val }))
                if (modal) {
                    setModal(false)
                }
            }
        }) 
       
    }

    const tableHeaderstyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor: "#ccc"

            },
        }
    }

    useEffect(() => {

        if(props.deleteCommunityPost.loading){
            Swal.fire({
                allowOutsideClick : false,
                didOpen: () => {
                    Swal.showLoading()
                    
                }
            });
        }
        else{
            if (props.deleteCommunityPost.deletecommunitypost.length) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Successfully deleted!',
                    icon : 'success',
                    timer: 3000
                })
          }
          else if (typeof props.deleteCommunityPost.error !== "undefined") {
            Swal.fire({
              title: 'Failed!',
              text: 'Something went wrong!',
              icon : 'error',
              timer: 3000
            })
          }
        }
    
    }, [props.deleteCommunityPost])

    return (  
        <>
  
            <Card className="shadow">
                <CardHeader className="border-0">
                    Manage Community Post              
                </CardHeader>
                <CardBody>
                    {
                        data.length ?
                        <DataTable 
                            // customStyles={ tableHeaderstyle}
                            columns={columns}
                            data={filter}
                            pagination
                            wrap
                            // selectableRows
                            // fixedHeader
                            selectableRowsHighlight
                            highlightOnHover
                        
                            subHeader
                            subHeaderComponent={
                                <input type="text"
                                className="w-25 form-control"
                                placeholder="Search a keyword content..."
                                value={ search}
                                onChange={(e)=>setSearch(e.target.value)}
                                />
                            }
                            subHeaderAlign="right"  
                        />
                    :  <Alert color="primary">
                        No data available .
                    </Alert>
                    }
                    
                    
                </CardBody>
            </Card>         
            <Modal isOpen={modal} toggle={modalToggle}  backdrop={backdrop} size="lg">
                <ModalHeader toggle={modalToggle}>{ 'Post ID: '+postId }</ModalHeader>
                <ModalBody>
                    {
                        postItem ?
                            <Post key={postId} item={postItem} />
                            // console.log(postItem)
                        : ''
                  }
                  
                </ModalBody>
                <ModalFooter className="">
                    <Button color="secondary" onClick={modalToggle}>
                        Cancel
                    </Button>
                    <Button  color="danger" onClick={e => handleDelete(postId)}>
                        Delete
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
  
}

const mapStateToProps = state  => {
    return {
        userDetails: state.loginAuth.userDetails,
        deleteCommunityPost : state.deleteCommunityPost
    }
      
}

export default connect(mapStateToProps)(ManagePosts)

